import React, { Fragment } from 'react';
import get from 'lodash/get';

import propTypes from 'prop-types';
import accountPropTypes from 'apps/account/propTypes';
import { TranslatedMessage } from 'common/components/Intl';
import IconInfo from '!svg-react-loader?!images-react-svg/icons/icon-info.svg';
import QuickShopOptionType from './QuickShopOptionType';
import QuickShopOptionValue from './QuickShopOptionValue';

export default class NicotineOptions extends React.Component {
  static propTypes = {
    variants: propTypes.array.isRequired,
    selectedVariant: accountPropTypes.ProductVariant,
    changeSelectedVariant: propTypes.func.isRequired,
  };

  availableOptionValues = optionType => {
    return [...new Set(this.props.variants.map(v => v[optionType]))]
      .sort()
      .reverse();
  };

  // A temporary experiment to see if the new text has a quantifiable impact on
  // add to cart events.
  nicotineStrengthText = () => {
    const nicotineStrengthExperiment = get(
      this.props,
      'splitTreatments.nicotine-strength-text'
    );

    return nicotineStrengthExperiment === 'on' ? (
      'Choose Your Nicotine Strength'
    ) : (
      <TranslatedMessage id={'cart.quick_shop.nicotine_strength'} />
    );
  };

  nicotineOptionTypeTitle = () => {
    const tooltipKey = this.props.selectedVariant.hasJ2NicotineStrength
      ? 'cart.quick_shop.nicotine_tooltip_j2'
      : 'cart.quick_shop.nicotine_tooltip';

    return (
      <Fragment>
        {this.nicotineStrengthText()}
        <div className="tooltip NicotineOptions__tooltip">
          <IconInfo />
          <span className="tooltip__text text--body--small">
            <TranslatedMessage id={tooltipKey} />
          </span>
        </div>
      </Fragment>
    );
  };

  getPendingVariant = nicStrength => {
    return this.props.variants.find(
      v =>
        v.nicotineStrength === nicStrength &&
        v.podCount === this.props.selectedVariant.podCount
    );
  };

  render() {
    const { selectedVariant, changeSelectedVariant, variants } = this.props;
    const optionType = 'nicotineStrength';

    const nicotineOptionValues = this.availableOptionValues(optionType).map(
      (optionValue, index) => (
        <QuickShopOptionValue
          key={optionType + index}
          optionValue={optionValue}
          optionValueLabel={optionValue}
          optionType={optionType}
          variants={variants}
          selectedVariant={selectedVariant}
          changeSelectedVariant={changeSelectedVariant}
          pendingVariant={this.getPendingVariant(optionValue)}
        />
      )
    );

    return (
      <QuickShopOptionType title={this.nicotineOptionTypeTitle()}>
        {nicotineOptionValues}
      </QuickShopOptionType>
    );
  }
}
